import { Heading } from "../Heading";
import { useTranslation } from "react-i18next";
import type { I18NHeadingProps } from "./I18NHeading.interface";

/**
 * Primary UI component for user interaction
 */
export function I18NHeading({ id, className, i18n, options, type, style }: I18NHeadingProps) {
	const { t } = useTranslation();
	return (<Heading id={id} className={className} text={t(i18n, { ...options })} type={type} style={style} />);
}
